import { clearError, errorMessage, SendErrorLog, setError } from "./GlobalUtility";
import { io } from "socket.io-client";
import { ref, watch } from "vue";
import { showNotification } from "./Notification";
// import { Buffer } from "buffer";

// Main URL 주소 조합   // 개발모드 설정
const mainUrl = (process.env.NODE_ENV === 'development') ? 'https://qls.peratech.co.kr/api/' : process.env.VUE_APP_SERVER_URL;
const categoryMap = {
  location: "locations",
  geofence: "geofences",
  device: "devices",
  group: "groups",
  auth: "authorities",
  event: "events",
  operation: "opimages",
  log: "logs",
  user: "users",
  marker: "markers",
  setting: "settings",
  weather: "weathers",
  rrs: "rrs",
  ptts: "ptts"
};
export const mixedUrl = (type) => {
  return mainUrl + categoryMap[type];
}

// 이미지 업로드 주소 조합
export const imageUrl = () => {
  // 개발모드 설정
  if (process.env.NODE_ENV === 'development') return 'https://qls.peratech.co.kr/uploads/images/';

  return "/uploads/images/";
}

// 타임아웃
export const TIMEOUT = 5000; // 타임아웃 시간 설정

// 서버 에러 문구
export const SERVER_ERROR = "Server is not open"; // 서버가 열리지 않았을 경우 문구 설정

// PUT POST DELETE 작업
export const SERVER_REQUEST = async (fName, method, body, showAlarm = true, contentTypeHeader = { 'Content-Type': 'application/json' }, url = 'default') => {
  try {
    if (url === 'default') url = mixedUrl(fName);
    else url = mixedUrl(fName) + url;

    const result = await fetch(url, {
                            method: method,
                            ...(contentTypeHeader && {headers: contentTypeHeader}),
                            contentTypeHeader,
                            body: body
                            // body: encryptData(body)
                        })
    const data = await result.json(); // 🚀 응답이 올 때까지 기다림
    if (data.message) {
        if (showAlarm) showNotification(data.message, 'alarm', 'top-center');
        return data;
    } else {
        console.error('Error: ', data);
        alert(data.error);
        return data.error;
    }
  } catch (err) {
    console.error('Error: ', err);
    alert(err);
    SendErrorLog('API', err);
    return err;
  }
}

// GET 작업
export const GET_SERVER_REQUEST = async (type, param = '') => {
  try {
    const isApiUp = mainUrl + categoryMap[type];
    if (isApiUp !== SERVER_ERROR) {
      const response = await fetch(isApiUp + param).then((res) => res.json());
      return response;
    } else {
        switch(type) {
            case ('device'):
                return [{ device_id: SERVER_ERROR, device_name: "-", group_id: "0", created_at: "2024-10-05T04:10:00.000Z", update_interval: 30000}];
            case ('group'):
                return [{ group_id: SERVER_ERROR, group_name: "-"}];
        }
    }
  } catch (err) {
    SendErrorLog('API', err);
    console.error('Error fetching data:', err);
  }
}


export const socket = io((process.env.NODE_ENV === 'development') ? 'https://qls.peratech.co.kr/' : "", {
  reconnection: true, // 자동 재연결 허용
  reconnectionAttempts: 5, // 최대 5번 재연결 시도
  reconnectionDelay: 2000, // 재연결 시도 간격 (2초)
});

const connectionError = ref(false); // Vue 상태 관리

// 최초 연결 실패 여부를 sessionStorage에 저장
if (sessionStorage.getItem("socketError") === null) {
  sessionStorage.setItem("socketError", "false");
}

socket.on("connect", () => {
  console.log("✅ 서버와 정상적으로 연결됨");
  connectionError.value = false;
  sessionStorage.setItem("socketError", "false"); // 연결되면 오류 상태 초기화
});

socket.on("connect_error", (err) => {
  if (sessionStorage.getItem("socketError") === "false") {
    console.error("❌ 서버 연결 실패:", err.message);
    sessionStorage.setItem("socketError", "true"); // 최초 한 번만 오류 표시
    errorMessage.value = "❌ 서버 연결 실패:" + err.message;
  }
  connectionError.value = true;
});

// 서버 연결 상태를 감시하여 UI에서 처리 가능
export function useSocketStatus() {
  return { connectionError };
}
watch(connectionError, (newVal) => {
  if (newVal) {
    errorMessage.value = "❌ 서버 연결 실패"
    setError(errorMessage.value);
  }
  else clearError();
});



export const user_list = ref([]);
export const device_list = ref([]);
export const group_list = ref([]);
export const geofence_list = ref([]);
export const auth_list = ref([]);
export const poi_list = ref([]);
export const event_list = ref([]);
export const log_list = ref([]);